import { config } from "@fortawesome/fontawesome-svg-core"

import { setDefaultConsent } from "./src/components/cookie-settings"

import "@fontsource/dm-sans"
import "@fontsource/dm-sans/500.css"
import "@fontsource/dm-sans/700.css"
import "@fontsource/dm-mono"
import "@fontsource/dm-mono/500.css"

// Global CSS lives here, not in Layout: imported from the app entry it always
// comes first, whatever order each page imports its components in. Otherwise
// mini-css-extract-plugin can't settle a single CSS order ("Conflicting order").
import "./src/styles.css"
// This ensures that the icon CSS is loaded immediately before attempting to render icons
import "@fortawesome/fontawesome-svg-core/styles.css"

// Prevent fontawesome from dynamically adding its css since we did it manually above
config.autoAddCss = false

// Señales del modo de consentimiento de Google. `onClientEntry` corre antes
// del primer `onRouteUpdate`, que es donde el plugin carga Analytics.
export const onClientEntry = () => {
  setDefaultConsent()
}
